import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { bool, object, func } from 'prop-types';
import { ALERT_TYPE, OPERATION_MODE, ShowToastMessage } from '@laramie/ui';
import { TableCustom } from '../../common';
import { useLista } from '../../../components/hooks/useLista';
import { useManagedContext } from '../../hooks';


const CertificadosApremiosGrid = (props) => {

    const { showMessageModal } = useManagedContext()

    //hooks
    let navigate = useNavigate();

    const [state, setState] = useState({
        idApremio: 0,
        list: []
    });

    const mount = () => {
        setState(prevState => {
            const list = props.data.list;
            return {...prevState,
              idApremio: props.data.idApremio,
              list: list };
        });
    }
    useEffect(mount, [props.data]);

    const [, getRowLista ] = useLista({
        listas: ['TipoDocumento','EstadoCertificadoApremio'],
        onLoaded: (listas, isSuccess, error) => {
          if (!isSuccess) {
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
          }
        },
        memo: {
          key: 'EstadoCertificadoApremio_TipoDocumento',
          timeout: 0
        }
    });

    const getDescTipoDocumento = (id) => {
        const row = getRowLista('TipoDocumento', id);
        return (row) ? row.nombre : '';
    }

    const getDescEstadoCertificadoApremio = (id) => {
        const row = getRowLista('EstadoCertificadoApremio', id);
        return (row) ? row.nombre : '';
    }

    const cellV = ({value}) =>  <div className='action'>
                                    {props.allowViewDetail &&
                                    <div onClick={ (event) => handleClickCertificadoView(value) } className="link">
                                        <span className="material-symbols-outlined" title="Ver">search</span>
                                    </div>}
                                    {props.allowUnbind && props.onUnbind &&
                                    <div onClick={ (event) => handleClickCertificadoUnbind(value) } className="link">
                                        <span className="material-symbols-outlined" title="Desvincular">link</span>
                                    </div>}
                                </div>

    const tableColumns = [
        { Header: 'N° Certificado', accessor: 'numero', width: '15%' },
        { Header: 'Estado certificado', Cell: (data) => getDescEstadoCertificadoApremio(data.value), accessor: 'idEstadoCertificadoApremio', width: '30%' },
        { Header: 'Cuenta', Cell: (data) => data.row.original.numeroCuenta??"", accessor: 'idCuenta', width: '15%' },
        { Header: 'Titular', Cell: (data) => 
                                (data.row.original.nombreContribuyente) ?
                                    `${data.row.original.nombreContribuyente} 
                                    (${getDescTipoDocumento(data.row.original.idTipoDocumentoContribuyente)}
                                    ${data.row.original.numeroDocumentoContribuyente})`
                                : '', width: '35%' },
        { Header: '', Cell: cellV, id:'abm', accessor: 'id', width: '5%', disableGlobalFilter: true, disableSortBy: true }
    ];

    //handles
    const handleClickCertificadoView = (id) => {
        const url = '/certificado-apremio/' + OPERATION_MODE.VIEW + '/' + id;
        navigate(url, { replace: true });
    }
    const handleClickCertificadoUnbind = (id) => {
        showMessageModal({
            title: "Confirmación",
            message: "¿Está seguro/a de desvincular el certificado del apremio?",
            onConfirm: () => props.onUnbind(id),
        })
    }




    return (
    <>

        <TableCustom
            showFilterGlobal={false}
            className={'TableCustomBase'}
            columns={tableColumns}
            data={ state.list }
        />

    </>
    );
}

CertificadosApremiosGrid.propTypes = {
    data: object.isRequired,
    allowViewDetail: bool.isRequired,
    allowUnbind: bool.isRequired,
    onUnbind: func
};

CertificadosApremiosGrid.defaultProps = {
    onUnbind: null,
};

export default CertificadosApremiosGrid;